import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { FlexRowEnd, hideScrollbar } from "../../../../../../Common/Styles";

export const HeaderContainer = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

export const TabContainer = styled.div<{ $selectedTabIndex: number }>`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  & > div > div {
    width: fit-content;
    & > div {
      &:last-child {
        height: ${ThisGorillaUtils.convertPxToRem("1")}rem;
      }

      label {
        font-size: ${({ theme }) => theme.typography.Body.L["font-size"]}rem;
        line-height: ${({ theme }) => theme.line_height["line-height-200"]}rem;
      }
    }

    &:nth-child(${({ $selectedTabIndex }) => $selectedTabIndex + 1}) {
      & > div:last-child {
        height: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
      }

      label {
        color: ${({ theme }) => theme.Color.text["text-emphasize-brand"].value};
      }
    }
  }
`;
export const FooterContainer = styled(FlexRowEnd)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

export const ListContainer = styled.div`
  max-height: ${ThisGorillaUtils.convertPxToRem("292")}rem;
  overflow: auto;
  ${hideScrollbar}
`;
